export default "__VITE_ASSET__CZOfSS5Y__"